/**
 * Phi Quick Add - Variant picker with Swiper carousel
 * Manages variant selection, price updates, and scroll-into-view for carousel
 */
(function () {
  'use strict';

  function formatMoney(cents, formatString) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatMatch = formatString && formatString.match ? formatString.match(placeholderRegex) : null;
    var formatKey = formatMatch && formatMatch[1] ? formatMatch[1] : 'amount';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }

    switch (formatKey) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString && formatString.replace ? formatString.replace(placeholderRegex, value) : value;
  }

  function scrollSelectedIntoView(fieldset) {
    var swiperContainer = fieldset.querySelector('swiper-container');
    if (!swiperContainer) return;

    function doSlide() {
      var checked = fieldset.querySelector('input:checked');
      if (!checked) return;
      var slide = checked.closest('swiper-slide');
      if (!slide) return;
      var slides = swiperContainer.querySelectorAll('swiper-slide');
      var index = Array.prototype.indexOf.call(slides, slide);
      if (index >= 0) {
        swiperContainer.swiper.update();
        swiperContainer.swiper.slideTo(index, 300);
      }
    }

    if (swiperContainer.swiper) {
      doSlide();
    } else {
      swiperContainer.addEventListener('swiperready', doSlide, { once: true });
    }
  }

  function PhiQuickAdd(container) {
    this.container = container;
    this.productId = container.getAttribute('data-product-id');
    this.moneyFormat = container.getAttribute('data-money-format') || '{{amount}}';
    this.addToCartText = container.getAttribute('data-add-to-cart-text') || 'Add to cart';
    this.soldOutText = container.getAttribute('data-sold-out-text') || 'Sold out';

    if (!this.productId || container.getAttribute('data-phi-initialized')) return;
    container.setAttribute('data-phi-initialized', 'true');

    this.init();
  }

  PhiQuickAdd.prototype.init = function () {
    var variantsEl = this.container.querySelector('[data-variants-json]');
    if (!variantsEl) return;

    this.variants = JSON.parse(variantsEl.textContent);
    this.inputs = this.container.querySelectorAll('[data-option-value]');
    this.priceEl = this.container.querySelector('[data-price]');
    this.colorLabelEl = this.container.querySelector('[data-color-label]');

    this.bindClose();
    this.bindVariantChange();
    this.update();
  };

  PhiQuickAdd.prototype.bindClose = function () {
    var self = this;
    var closeBtn = this.container.querySelector('[data-close-quick-add]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        self.close();
      });
    }
  };

  PhiQuickAdd.prototype.close = function () {
    var modal = this.container.closest('phi-quick-add-card-product, quick-add-modal, modal-dialog, .modal, [data-modal]');
    if (modal) {
      if (typeof modal.hide === 'function') {
        modal.hide();
      } else if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.classList.remove('active', 'open', 'is-open');
        modal.setAttribute('hidden', '');
      }
    }
  };

  PhiQuickAdd.prototype.update = function () {
    var idInput = this.container.querySelector('input[name="id"]');
    var submitBtn = this.container.querySelector('[type="submit"]');
    var fieldsets = this.container.querySelectorAll('.phi-quick-add__fieldset');
    var self = this;

    var selectedOptions = Array.prototype.map.call(fieldsets, function (fs) {
      var checked = fs.querySelector('input:checked');
      return {
        name: fs.getAttribute('data-option-name'),
        value: checked ? checked.value : '',
        isColor: fs.hasAttribute('data-is-color')
      };
    });

    var variant = selectedOptions.length === 0
      ? this.variants[0]
      : this.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === (selectedOptions[i] && selectedOptions[i].value);
          });
        });

    if (this.colorLabelEl && selectedOptions.find(function (o) { return o.isColor; })) {
      this.colorLabelEl.textContent = 'Color : ' + (selectedOptions.find(function (o) { return o.isColor; }).value || '');
    }

    selectedOptions.forEach(function (opt, i) {
      if (!opt.isColor && opt.value) {
        var fs = fieldsets[i];
        if (fs) {
          var sizeSpan = fs.querySelector('[data-size-selected]');
          if (sizeSpan) sizeSpan.textContent = opt.value;
        }
      }
    });

    if (variant) {
      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = false;
      }
      if (this.priceEl) this.priceEl.textContent = formatMoney(variant.price, this.moneyFormat);
      if (submitBtn) {
        var textSpan = submitBtn.querySelector('.product-form__submit-text') || submitBtn.querySelector('span:not(.button__icon-wrap)');
        if (textSpan) {
          if (variant.available) {
            submitBtn.removeAttribute('disabled');
            textSpan.textContent = this.addToCartText;
          } else {
            submitBtn.setAttribute('disabled', 'disabled');
            textSpan.textContent = this.soldOutText;
          }
        }
      }
    } else if (idInput) {
      idInput.disabled = true;
    }
  };

  PhiQuickAdd.prototype.bindVariantChange = function () {
    var self = this;
    Array.prototype.forEach.call(this.inputs, function (inp) {
      inp.addEventListener('change', function () {
        self.update();
        var fieldset = inp.closest('.phi-quick-add__fieldset');
        if (fieldset) scrollSelectedIntoView(fieldset);
      });
    });
  };

  function initAll() {
    var containers = document.querySelectorAll('.phi-quick-add[data-product-id]');
    Array.prototype.forEach.call(containers, function (el) {
      new PhiQuickAdd(el);
    });
  }

  function observeNewContainers() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('phi-quick-add') && node.getAttribute('data-product-id')) {
              new PhiQuickAdd(node);
            }
            var quickAdds = node.querySelectorAll ? node.querySelectorAll('.phi-quick-add[data-product-id]') : [];
            Array.prototype.forEach.call(quickAdds, function (el) {
              new PhiQuickAdd(el);
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      observeNewContainers();
    });
  } else {
    initAll();
    observeNewContainers();
  }

  window.PhiQuickAdd = PhiQuickAdd;
})();
